import { SecureService } from './secureService'
import { Config } from '../utilities/config'

class _Service extends SecureService {

  trackExperiment = async (params) => {
    const response = await fetch(Config.services.analytics.trackExperiment, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })
    const jsonResponse = await response.json()
    return jsonResponse
  }

}

const abTestService = new _Service()
export { abTestService }